/**
 * Single source of truth for brand, contact address and inquiry links.
 *
 * AUTHORITATIVE contact address (owner lock, 2026-10-14). This is the ONLY place
 * the address is written; every page imports CONTACT_EMAIL / MAILTO_PLAIN /
 * mailtoHref() from here. tests/policy/contact-email.policy.test.tsx fails the
 * build of trust if any other FairCorp mailbox literal appears in hosting source.
 */
export const CONTACT_EMAIL = 'faircorp.info@gmail.com';

export const BRAND_NAME = 'FairCorp Hosting & Development';
export const HUB_URL: string = import.meta.env.VITE_HUB_URL ?? 'http://fair-corp.com';

export type InquiryKind = 'development' | 'hosting' | 'both' | 'general';

export const INQUIRY_SUBJECT: Record<InquiryKind, string> = {
  development: 'Development inquiry',
  hosting: 'Hosting inquiry',
  both: 'Development + hosting inquiry',
  general: 'Question',
};

/** Build a mailto: URL (RFC 6068: percent-encoded subject/body, CRLF line breaks). */
export function mailtoHref(kind: InquiryKind = 'general', bodyLines: string[] = []): string {
  const params = [`subject=${encodeURIComponent(`${BRAND_NAME} — ${INQUIRY_SUBJECT[kind]}`)}`];
  if (bodyLines.length > 0) params.push(`body=${encodeURIComponent(bodyLines.join('\r\n'))}`);
  return `mailto:${CONTACT_EMAIL}?${params.join('&')}`;
}

/** Plain address link (policy pages, footer). */
export const MAILTO_PLAIN = `mailto:${CONTACT_EMAIL}`;
